"use strict";

// https://html.spec.whatwg.org/multipage/window-object.html#browser-interface-elements
class BarPropImpl {}

// Since many BarProps do not apply to modern browsers,
// returning true in all cases seems to be common practice.
BarPropImpl.prototype.visible = true;

exports.implementation = BarPropImpl;



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/window/BarProp-impl.js
// module id = 6+N7
// module chunks = 0